exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Header__Modal-module___6GXGV {\n    border-bottom: none;\n    padding: 24px 36px;\n}\n\n.Body__Modal-module___29iFD {\n    padding: 0px 36px 24px;\n}\n\n", ""]);

// Exports
exports.locals = {
	"Header": "Header__Modal-module___6GXGV",
	"Body": "Body__Modal-module___29iFD"
};